import { DefaultUrlSerializer, PRIMARY_OUTLET, UrlTree } from '@angular/router';

/** Keep legacy case-insensitive route/query names without corrupting IDs or tokens. */
export class IntakeUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const tree = super.parse(url);
    const first = tree.root.children[PRIMARY_OUTLET]?.segments[0];
    if (first && ['political','pledge','paysuccess','payfailed'].includes(first.path.toLowerCase())) {
      first.path = first.path.toLowerCase();
    }
    tree.queryParams = Object.fromEntries(Object.entries(tree.queryParams).map(([key,value]) => [key.toLowerCase(),value]));
    return tree;
  }
}
